const isCombined = $(`#variant-options[data-type="Combined"]`).length > 0;
if (!customElements.get("variant-selects")) {
  /**
   *  @class
   *  @function VariantSelects
   */
  let pageInit = true;
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      if (pageInit) {
        this.mainProductFetch();
        pageInit = false;
      }
      this.isDisabledFeature = this.dataset.isDisabled;
      this.updateUrl = this.dataset.updateUrl === "true";
      this.addEventListener("change", this.onVariantChange);
      
      // Initialize variant selection handlers
      this.initializeVariantHandlers();
      
      this.productWrapper = this.closest(".thb-product-detail");
      this.productSlider = this.productWrapper.querySelector(".product-images");
      this.hideVariants = this.dataset.hideVariants === "true";
      this.updateProductVariant = this.updateProductVariant.bind(this);
      this.updateMedia();
    
      setTimeout(() => {
          this.updateOptions();
          this.updateMasterId();
          this.updateDescription();
          this.updateMedia();
      }, 1000);
    }
    connectedCallback() {
      this.setDisabled();
    }

    initializeVariantHandlers() {
      // Handle size label clicks
      $(window).on('click', '.varient-selection-size-label', this.handleSizeLabelClick.bind(this));

      // Handle dropdown changes
      const select = document.getElementById("option-select-2");
      if (select) {
        select.addEventListener("change", (event) => this.updateSelectedVariant(event.target));
      }
    }

    handleSizeLabelClick(event) {
      const target = event.target;
      if (!target.classList.contains("varient-selection-size-label")) return;

      const fieldset = target.closest("fieldset");
      if (!fieldset) return;

      const dataHandle = fieldset.getAttribute("data-handle");
      const spanValue = target.getAttribute("data-value");
      const cookieName = `selected_prod_${dataHandle}`;
      
      // Update cookie
      setTimeout(() => {
        this.deleteCookie(cookieName);
        this.setCookie(cookieName, spanValue, 1);
      }, 1000);

      // Update variant selection
      const hiddenInput = document.getElementById("selected-variant-id");
      const dataId = target.getAttribute("data-id");
      if (hiddenInput && dataId) {
        hiddenInput.value = dataId;
        hiddenInput.dispatchEvent(new Event("change"));
      }
    }

    updateSelectedVariant(selectElement) {
      const selectedOption = selectElement.options[selectElement.selectedIndex];
      const dataId = selectedOption.getAttribute("data-id");
      const sku = selectedOption.getAttribute("data-sku");

      const hiddenInput = document.getElementById("selected-variant-id");
      if (hiddenInput && dataId) {
        hiddenInput.value = dataId;
        hiddenInput.dispatchEvent(new Event("change"));
      }

      // Update SKU display
      const skuElement = document.querySelector(".product-sku span.sku-value");
      if (skuElement && sku) {
        skuElement.innerHTML = sku;
      }
    }

    onVariantChange(event) {
      const isColor = event.target.name === 'Color';
      this.variantId = event.target.dataset.id;
      this.url = event.target.dataset.url;
      if (isColor) {
        window.history.replaceState({}, '', this.url);
      }

      // Update variant state
      this.updateProductVariant(event, isColor);
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, "", false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();

      if (!this.currentVariant) {
        this.toggleAddButton(true, "", true);
      } else {
        const variations = document.querySelector('.variations');
        const notLoaded = !variations.classList.contains('loaded');
        if (isColor || (!isColor && notLoaded)) {
          if (notLoaded) {
            variations.classList.add('loaded');
          }
        }
        this.renderProductInfo(isColor);
        if (isColor) {
          this.updateVariantInput();
        }
      }
      // Dispatch variant change event
      dispatchCustomEvent("product:variant-change", {
        variant: this.currentVariant,
        sectionId: this.dataset.section,
      });
      this.setDisabled(isColor);
    }
    updateDescription() {
      const descriptionEl = document.querySelector('.collapsible__content[data-desc]');
      if (!descriptionEl) return;
      const originalDesc = descriptionEl.dataset?.desc;
      const variantDesc = descMap[this.currentVariant?.id];
      const newDesc = variantDesc || originalDesc || '';
      if (newDesc !== descriptionEl.innerHTML) {
        descriptionEl.innerHTML = newDesc;
      }
    }

    updateProductVariant(event, isColor) {
      const radioTarget = event.target;
      if (!radioTarget) return;

      // Reset radio button states
      document.querySelectorAll(".varient-selection-label, .varient-selection-size-label").forEach(rb => {
        rb.checked = false;
      });

      const productUrl = radioTarget.getAttribute("data-url");
      if (productUrl) {
        this.fetchProductSections(productUrl).then(sections => {
          return this.replaceProductSections(sections, isColor)
        }).catch(error => console.error("Error updating product sections:", error));
      }
    }

    async fetchProductSections(productUrl) {
      try {
        const response = await fetch(`${productUrl}&view=sections-template`);
        const html = await response.text();
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;

        return {
          titleSection: tempDiv.querySelector(".product-title")?.innerHTML,
          variantsSectionContents: Array.from(tempDiv.querySelectorAll(".sizes-block")).map(section => section.innerHTML),
          variantsDataContents: tempDiv.querySelector('[data-variants][type="application/json"]')?.innerHTML,
          cartFormSection: tempDiv.querySelector(".product-add-to-cart-form")?.innerHTML,
          pricesection: tempDiv.querySelector(".product-information .product-price-container .price")?.innerHTML,
          style: tempDiv.querySelector(".product-sku")?.innerHTML,
          mediasection: this.getMediaSection(tempDiv)
        };
      } catch (error) {
        console.error("Error fetching product sections:", error);
        throw error;
      }
    }
    updateVariantUrl() {
      const checkedInput = document.querySelector('fieldset.product-form__input input[type="radio"]:checked');
      const checkedUrl = checkedInput.getAttribute("data-url");
      window.history.replaceState({}, "", `${checkedUrl}`);
    }
    getMediaSection(tempDiv) {
      if (document.querySelector("#Product-Quick-Slider")) {
        return tempDiv.querySelector(".product-image-container")?.innerHTML;
      }
      return tempDiv.querySelector(".small-12.large-7.columns")?.innerHTML;
    }

    async replaceProductSections(sections, isColor) {
      if (!sections) return;

      // Update product sections
      this.updateProductSections(sections);
      
      // this.updateVariantUrl();

      // Update variant selection and cookies
      this.handleCookiesOnLoad();

      // Update variants and format sizes
      // await updateVariants();
      initializeRadioButtons();
      formatSizes();
      this.updateOptions();
      this.updateMasterId();
      this.updateMedia();
      this.updateDescription();
    }

    updateProductSections(sections) {
      const elements = {
        title: document.querySelector(".product-title"),
        variants: document.querySelectorAll(".sizes-block"),
        variantsData: document.querySelector('variant-selects script[type="application/json"]'),
        cartForm: document.querySelector(".product-add-to-cart-form"),
        price: document.querySelector(".product-information .product-price-container .price"),
        sku: document.querySelector(".product-sku")
      };

      if (elements.title) elements.title.innerHTML = sections.titleSection;
      if (elements.variantsData) elements.variantsData.innerHTML = sections.variantsDataContents;
      if (elements.cartForm) elements.cartForm.innerHTML = sections.cartFormSection;
      if (elements.price) elements.price.innerHTML = sections.pricesection;
      if (elements.sku) elements.sku.innerHTML = sections.style;

      elements.variants?.forEach((container, index) => {
        if (sections.variantsSectionContents[index]) {
          container.innerHTML = sections.variantsSectionContents[index];
        }
      });
    }

    async updateMediaSections(sections) {
      const mediaContainer = document.querySelector(".small-12.large-7.columns") || 
                            document.querySelector(".product-gallery-sticky");
      
      if (mediaContainer && sections.mediasection) {
        mediaContainer.innerHTML = sections.mediasection;
        
        // Hide zoom element if present
        const mediaZoomElement = document.querySelector(".product-single__media-zoom");
        if (mediaZoomElement) {
          mediaZoomElement.style.display = "none";
        }
      }
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll("fieldset"));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector("select")) {
          this.options.push(fieldset.querySelector("select").value);
        } else if (fieldset.querySelectorAll("input").length) {
          this.options.push(fieldset.querySelector(".form__label__value").textContent);
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll("fieldset"));
      fieldsets.forEach((item, i) => {
        let labelValueSpan = item.querySelector(".form__label__value");
        if (labelValueSpan) {
          if (
            item.dataset.index === "option1" &&
            item.dataset.handle === "color"
          ) {
            const selectedInput = item.querySelector( 'input[type="radio"]:checked' );

            if (selectedInput) {
              const selectedLabel = item.querySelector(
                `label[for="${selectedInput.id}"]`
              );
              if (selectedLabel) {
                const colorValue =
                  selectedLabel.getAttribute("title") ||
                  selectedLabel.getAttribute("data-value");
                labelValueSpan.innerHTML = colorValue;
              }
            }
          } else {
            if (this.options[i] !== undefined) {
              labelValueSpan.innerHTML = this.options[i];
            }
          }
        }
      });
    }
    updateMasterId() {
      const variantData = this.getVariantData();
      this.currentVariant = variantData.find((variant) => {
        return variant.options.every((option, index) => {
          return this.options[index] === option;
        });
      });
    }

    async updateMedia() {
      if (!this.currentVariant || (!isCombined && !this.currentVariant.featured_media)) return;
      let thumbnails = document.querySelector('#Product-Thumbnails');
      if (this.productSlider && thumbnails) {
        if (isCombined) {
          // await this.mainProductFetch();
          const variantColor = document.querySelector('.product-form__input--color .form__label__value').textContent;
          $(`.product-thumbnail:not([data-color="${variantColor}"]), .product-images__slide:not([data-color="${variantColor}"])`)
            .removeClass('is-active')
            .prop('disabled', true);
          $(`.product-thumbnail[data-color="${variantColor}"], .product-images__slide[data-color="${variantColor}"]`)
            .addClass('is-active')
            .prop('disabled', false);
          this.setActiveMedia(
            `.product-images__slide[data-color="${variantColor}"]`,
            `.product-thumbnail[data-color="${variantColor}"]`,
            this.productSlider,
            thumbnails,
            true
          );
        } else {
          this.setActiveMedia(
            `#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`,
            `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`,
            this.productSlider,
            thumbnails
          );
        }
      }
    }
    setActiveMedia(mediaId, thumbId, productSlider, thumbnails, combined = false) {
      let flkty = Flickity.data(productSlider),
        activeMedia = productSlider.querySelectorAll(mediaId)[0];
      if (flkty) {
        if (this.hideVariants) {
          if (!combined) {
            if ( productSlider.querySelector( ".product-images__slide.is-initial-selected" ) ) {
              productSlider.querySelector(".product-images__slide.is-initial-selected")
                .classList.remove("is-initial-selected");
            }
            productSlider.querySelectorAll( ".product-images__slide" ).forEach(el => {
              el.classList.remove("is-active");
            });
            activeMedia.classList.add("is-active");
            activeMedia.classList.add("is-initial-selected");
          }
          this.setImageSetMedia();

          if (thumbnails) {
            let activeThumbs = thumbnails.querySelectorAll(thumbId);
            
            if ( thumbnails.querySelector(".product-thumbnail.is-initial-selected") ) {
              thumbnails
                .querySelector(".product-thumbnail.is-initial-selected")
                .classList.remove("is-initial-selected");
            }
            thumbnails.querySelectorAll(".product-images__slide").forEach(el => {
              el.classList.remove("is-active");
            });
            if (activeThumbs.length > 0) {
              activeThumbs.forEach(thumb => {
                thumb.classList.add("is-active");
              });
              activeThumbs[0].classList.add("is-initial-selected");
            }
          }
          if (productSlider?.reInit) {
            productSlider.reInit();
          }
        }
        productSlider?.selectCell(mediaId);
      }
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === "false") return;
      var titleWithHyphens = this.currentVariant.title.replace(/ /g, "-");
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}/${titleWithHyphens
          .toLowerCase()
          .replace("/", "-")
          .trim()
          .replace(" ", "-")}`
      );
    }

    updateShareUrl() {
      const shareButton = document.getElementById(
        `Share-${this.dataset.section}`
      );
      if (!shareButton) return;
      shareButton.updateUrl(
        `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
      );
    }

    updateVariantInput() {
      this.updateOptions();
      this.updateMasterId();
      if (this.currentVariant?.id) {
        const productForms = document.querySelectorAll( `#product-form-${this.dataset.section}, #product-form-installment` );
        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent( new Event("change", { bubbles: true, }) );
        });
      }
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector(
        ".pickup-availability-wrapper"
      );

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant?.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute("available");
        pickUpAvailability.innerHTML = "";
      }
    }

    removeErrorMessage() {
      const section = this.closest("section");
      if (!section) return;

      const productForm = section.querySelector("product-form");
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [
        `price-${this.dataset.section}`,
        `inventory-${this.dataset.section}`,
        `sku-${this.dataset.section}`,
      ];
    }
    renderProductInfo(isColor = false) {
      let sections = this.getSectionsToRender();
      fetch(
        `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
      )
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);

            if (price) price.classList.remove("visibility-hidden");
          });
          this.toggleAddButton(
            !this.currentVariant?.available,
            window.theme.variantStrings.soldOut
          );
          this.updateVariantInput();
          if (this.productSlider) {
            this.productSlider.reInit();
          }
          this.setDisabled(isColor);
        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(
        `product-form-${this.dataset.section}`
      );
      if (!productForm) return;

      const productTemplate = productForm
        .closest(".product-form")
        .getAttribute("template");
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');

      if (!addButton) return;

      if (disable) {
        //addButton.setAttribute('disabled', 'disabled');
        //if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute("disabled");
        addButton.classList.remove("loading");
        addButtonText.textContent = window.theme.variantStrings.addToCart;

        if (productTemplate?.includes("pre-order")) {
          addButtonText.textContent = window.theme.variantStrings.preOrder;
        } else {
          addButtonText.textContent = window.theme.variantStrings.addToCart;
        }
      }
      if (!modifyClass) return;
    }

    setUnavailable() {
      const button = document.getElementById(
        `product-form-${this.dataset.section}`
      );
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      const price = document.getElementById(`price-${this.dataset.section}`);
      if (!addButton) return;
      addButtonText.textContent = window.theme.variantStrings.unavailable;
      addButton.classList.add("sold-out");
      if (price) price.classList.add("visibility-hidden");
    }

    setDisabled(isColor = false) {
      if (this.isDisabledFeature != 'true') {
        return;
      }
      setTimeout(() => {
        this.updateVariantInput();
        const variant_data = this.getVariantData();
        if (variant_data) {
          let selected_options = false;
          if (this.currentVariant) {
            selected_options = this.currentVariant.options.map((value, index) => {
              return {
                value,
                index: `option${index + 1}`
              };
            });
          } else {
            let found_option = variant_data.find(option => {
              return option.option1 === this.options[0];
            });
            if (found_option) {
              selected_options = [
                {
                  "value": this.options[0],
                  "index": "option1"
                },
                {
                  "value": found_option.option2,
                  "index": "option2"
                }
              ];
            } else {
              return;
            }
          }
          const available_options = this.createAvailableOptionsTree(variant_data, selected_options);
          this.fieldsets.forEach((fieldset, i) => {
            const notColor = !isColor && i == 0;
            const fieldset_options = Object.values(available_options)[i];
            if (fieldset_options) {
              if (fieldset.querySelector('select')) {
                fieldset_options.forEach((option, option_i) => {
                  const optionElement = fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']');
                  if (optionElement) {
                    optionElement.disabled = option.isUnavailable;
                  }
                });
              } else if (fieldset.querySelectorAll('input').length) {
                fieldset.querySelectorAll('input').forEach((input, input_i) => {
                  let fieldsetData = fieldset_options.find(option => option.option1 == input.value);
                  if (fieldsetData) {
                    const available = fieldsetData.some(option => option.available);
                    if (notColor) {
                      available = !variant_data.find(variant => variant.options[0] == input.value && variant.options[1] == selected_options[1].value)?.available;
                    }
                    if (available) {
                      input.classList.remove('is-disabled');
                    } else {
                      input.classList.add('is-disabled');
                    }
                  }
                });
              }
            }
          });
        }
      }, 1000);
      return true;
    }


    getImageSetName(variant_name) {
      return variant_name
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/-$/, "")
        .replace(/^-/, "");
    }

    setImageSet() {
      if (!this.productSlider) return;
      let dataSetEl = this.productSlider.querySelector("[data-set-name]");
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector(
          '.product-form__input[data-handle="' + this.imageSetName + '"]'
        ).dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;
        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      if (!this.imageSetIndex && !isCombined) {
        return;
      }
      if (this.imageSetIndex) {
        let selected_set_images, selected_set_thumbs;
        let setValue = this.getImageSetName(
          this.currentVariant[this.imageSetIndex]
        );
        let group = this.imageSetName + "_" + setValue;
        selected_set_images = this.productWrapper.querySelectorAll( `.product-images__slide[data-set-name="${this.imageSetName}"]` );
        selected_set_thumbs = this.productWrapper.querySelectorAll( `.product-thumbnail[data-set-name="${this.imageSetName}"]` );
        if (this.hideVariants) {
          // Product images
          this.productWrapper
            .querySelectorAll(".product-images__slide")
            .forEach((thumb) => {
              if (thumb.dataset.group && thumb.dataset.group !== group) {
                thumb.classList.remove("is-active");
              }
            });
          selected_set_images.forEach((thumb) => {
            thumb.classList.toggle("is-active", thumb.dataset.group === group);
          });
          // Product thumbnails
          this.productWrapper.querySelectorAll(".product-thumbnail").forEach((thumb) => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove("is-active");
            }
          });
          selected_set_thumbs.forEach((thumb) => {
            thumb.classList.toggle("is-active", thumb.dataset.group === group);
          });
        }
      }
    }

    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce(
        (options, variant) => {
          // Check each option group (e.g. option1, option2, option3) of the variant
          Object.keys(options).forEach((index) => {
            if (variant[index] === null) return;

            let entry = options[index].find(
              (option) => option.value === variant[index]
            );

            if (typeof entry === "undefined") {
              // If option has yet to be added to the options tree, add it
              entry = {
                value: variant[index],
                isUnavailable: true,
              };
              options[index].push(entry);
            }
            // Check how many selected option values match a variant
            const countVariantOptionsThatMatchCurrent = selected_options.reduce(
              (count, { value, index }) => {
                return variant[index] === value ? count + 1 : count;
              },
              0
            );

            // Only enable an option if an available variant matches all but one current selected value
            if (
              countVariantOptionsThatMatchCurrent >=
              selected_options.length - 1
            ) {
              entry.isUnavailable =
                entry.isUnavailable && variant.available
                  ? false
                  : entry.isUnavailable;
            }

            // Make sure if a variant is unavailable, disable currently selected option
            if (
              (!this.currentVariant || !this.currentVariant?.available) &&
              selected_options.find(
                (option) =>
                  option.value === entry.value && index === option.index
              )
            ) {
              entry.isUnavailable = true;
            }

            // First option is always enabled
            if (index === "option1") {
              entry.isUnavailable =
                entry.isUnavailable && variant.available
                  ? false
                  : entry.isUnavailable;
            }
          });

          return options;
        },
        {
          option1: [],
          option2: [],
          option3: [],
        }
      );
    }

    getVariantData() {
      this.variantData = JSON.parse(this.querySelector('[data-variants]').textContent);
      return this.variantData;
    }
    async fetchProductDetails(tag) {
        try {
            const response = await fetch(`https://${Shopify.shop}/api/2025-04/graphql.json`, {
                method: "POST",
                headers: {
                    'X-Shopify-Storefront-Access-Token': window.storefrontToken,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    query: `
                      query Products($query: String!, $country: CountryCode) @inContext(country: $country) {
                          products(first: 100, query: $query) {
                              edges {
                                  node {
                                      id
                                      title
                                      handle
                                      productType
                                      discontinued: metafield(namespace: "custom", key: "discontinued") {
                                          value
                                          type
                                      }
                                      color: metafield(namespace: "shopify", key: "color-pattern") {
                                        ...MetafieldFragment
                                        value
                                        type
                                        key
                                        namespace
                                        references(first: 10) {
                                            edges {
                                              node {
                                                ... on Metaobject {
                                                  fields {
                                                    key
                                                    value
                                                  }
                                                }
                                              }
                                            }
                                          }
                                      }
                                      totalInventory
                                      priceRange {
                                          maxVariantPrice {
                                              amount
                                              currencyCode
                                          }
                                          minVariantPrice {
                                              amount
                                              currencyCode
                                          }
                                      }
                                      media(first: 25) {
                                        edges {
                                          node {
                                            ... on MediaImage {
                                              image {
                                                altText
                                                url
                                                id
                                              }
                                            }
                                            alt
                                            id
                                          }
                                        }
                                      }
                                      variants(first: 100) {
                                          edges {
                                              node {
                                                  id
                                                  title
                                                  selectedOptions {
                                                      name
                                                      value
                                                  }
                                                  image {
                                                      url
                                                      altText
                                                      id
                                                  }
                                              }
                                          }
                                      }
                                  }
                              }
                          }
                      }
                      fragment MetafieldFragment on Metafield {
                        id
                        key
                      }
                    `,
                    variables: {
                        query: `tag:${tag} AND status:ACTIVE`,
                        country: Shopify.country
                    }
                })
            });
            const { data, errors } = await response.json();
            if (errors) {
                console.error('GraphQL Errors:', errors);
                return null;
            }
            if (data && data.products.edges) {
                const productDetails = data.products.edges
                  .map(({ node }) => {
                      if (node) {
                          return node;
                      } else {
                          console.warn("Encountered a null product.");
                          return null;
                      }
                  })
                  .filter(Boolean);
                return productDetails;
            } else {
                console.warn("No product data found.");
                return null;
            }
        } catch (error) {
            console.error("Error fetching product:", error);
            return []; // Return an empty array on error to prevent breaking subsequent code
        }
    }
    async mainProductFetch(init=false) {
        const productType = document.getElementById('variant-options').dataset.type;
        const productStyleNo = document.getElementById('product-style-num').value;
        let flkty = this.productSlider?.flkty;
        if (productType == 'Combined') {
          if (!this.productDetails) {
            this.productDetails = await this.fetchProductDetails(productStyleNo);
          }
          if (this.productDetails.length > 1) {
            this.productDetails = this.productDetails.filter(childProduct => childProduct.productType != 'Combined');
          }
          if (this.productDetails?.length > 1) {
            $('#Product-Thumbnails .product-thumbnail, #Product-Slider .product-images__slide').remove();
          }
          flkty = flkty || (new Flickity(this.productSlider, {
              wrapAround: true,
              pageDots: true,
              contain: true,
              initialIndex: init ? ".is-active.is-initial-selected" : ".is-initial-selected",
              adaptiveHeight: true,
              prevNextButtons: false,
              cellSelector: `.product-images__slide${init ? '.is-active' : ''}`,
          }));
          const thumbnails = document.querySelector('#Product-Thumbnails');
          // Add all variant images
          const sectionId = thumbnails.dataset.sectionId;
          const selectedColor = document.querySelector('.product-form__input--color .form__label__value').textContent;
          const processImages = (variantImages, variantColor, variantProduct) => {
            const isActive = (variantColor && selectedColor) ? variantColor.toLowerCase() === selectedColor.toLowerCase() : false;
            variantImages.forEach((image, idx) => {
              const imageId = image.id.split('/').pop();
              const isFirstOfVariant = idx == 0;
              const slide = document.createElement('div');
              const initialSelected = isActive && isFirstOfVariant;
              const slideId = `Slide-${sectionId}-${imageId}`;
              const imageUrl = image.url || image.src;
              const imageAlt = image.altText || image.alt || `${variantProduct.title} - ${variantColor}`;
              if (!$(`#${slideId}`).length) {
                slide.id = slideId;
                slide.className = `product-images__slide ${isActive ? 'is-active' : ''}${isFirstOfVariant ? ' first-of-variant' : ''}${initialSelected ? ' is-initial-selected' : ''}`;
                if (variantColor) {
                  slide.dataset.color = variantColor;
                }
                slide.dataset.variantId = variantProduct.id;
                slide.innerHTML = `
                  <div class="product-single__media product-single__media-image ${isFirstOfVariant ? 'first-of-variant' : ''}" data-color="${variantColor}">
                      <a href="${imageUrl}" class="product-single__media-zoom" data-msrc="${imageUrl}&amp;width=20" data-h="1280" data-w="853" target="_blank" tabindex="-1" aria-label="Zoom">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M4.24998 6.25022H8.24996M6.24997 4.25023V8.25021M9.96205 9.96248L12.9996 13M11.4999 6.24997C11.4999 9.14945 9.14945 11.4999 6.24997 11.4999C3.35049 11.4999 1 9.14945 1 6.24997C1 3.35049 3.35049 1 6.24997 1C9.14945 1 11.4999 3.35049 11.4999 6.24997Z" stroke="var(--color-accent)" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path> </svg>
                      </a>
                      <img class="" src="${imageUrl}" width="853" height="1280" data-sizes="auto" data-image-product-id fetchpriority="auto" sizes="578px" alt="${imageAlt}" />
                  </div>
                `;
                flkty.append(slide);
                $('#Product-Slider .flickity-slider').append(slide);
              }
              else {
                $(`#${slideId}`).addClass(isActive ? 'is-active' : '');
              }
              // Add to thumbnails
              const thumb = document.createElement('li');
              const thumbId = `Thumb-${sectionId}-${imageId}`;
              if (!$(`#${thumbId}`).length) {
                thumb.id = thumbId;
                thumb.className = `product-thumbnail ${isActive ? 'is-active' : ''}${isFirstOfVariant ? ' first-of-variant' : ''}${initialSelected ? ' is-initial-selected' : ''}`;
                thumb.innerHTML = `<img src="${imageUrl}" alt="${imageAlt}" />`;
                if (variantColor) {
                  thumb.dataset.color = variantColor;
                }
                thumbnails.appendChild(thumb);
              }
              else {
                $(`#${thumbId}`).addClass(isActive ? 'is-active' : '');
              }
            });
          }
          this.productDetails?.forEach(variantProduct => {
            // const variantVariants = variantProduct?.variants?.edges?.map(variant => variant.node);
            const variantColor = variantProduct?.color?.references.edges[0].node.fields.find(field => field.key == 'label')?.value;
            const variantImages = variantProduct?.media?.edges.map(img => img.node.image);
            if (variantImages.length) {
              processImages(variantImages, variantColor, variantProduct);
            }
          });
          if (flkty) {
            if (this.productSlider?.reInit) {
              this.productSlider.reInit();
            }
            else if (this.productSlider?.init) {
              this.productSlider.init();
            }
            else {
              flkty.destroy();
            }
          }
          if (!flkty) {
            flkty = this.productSlider?.flkty || (new Flickity('#Product-Slider', {
              wrapAround: true,
              pageDots: true,
              contain: true,
              initialIndex: init ? ".is-active.is-initial-selected" : ".is-initial-selected",
              adaptiveHeight: true,
              prevNextButtons: false,
              cellSelector: `.product-images__slide${init ? '.is-active' : ''}`,
            }));
          }
          document.querySelector('#variant-options').classList.add('loaded');
        }
    }

    handleCookiesOnLoad() {
      const self = this;
      document.querySelectorAll('.product-form__input:not([data-index="option1"])').forEach((fieldset) => {
        const dataHandle = fieldset.getAttribute("data-handle");
        const cookieName = `selected_prod_${dataHandle}`;
        const sizeCookie = this.getCookie(cookieName);
        
        if (sizeCookie) {
          fieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
            const label = input.nextElementSibling;
            if (input.value === sizeCookie) {
              const hiddenInput = document.getElementById("selected-variant-id");
              const hiddenInput1 = label.getAttribute("data-id");
              if (hiddenInput && hiddenInput1) {
                const selectedVariantId = hiddenInput1;
                // hiddenInput.value = selectedVariantId;
                // hiddenInput.dispatchEvent(new Event("change"));
              }
            }
          });
        }
      });
    }

    getCookie(name) {
      const nameEQ = name + "=";
      const ca = document.cookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    }

    setCookie(name, value, days) {
      let expires = "";
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    deleteCookie(name) {
      document.cookie = name + "=; Max-Age=-99999999; path=/";
    }
  }
  customElements.define("variant-selects", VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll("fieldset"));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked
        ).value;
      });
    }
    updateVariantText() {}
  }

  customElements.define("variant-radios", VariantRadios);
}

function initializeProductSlider() {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("change", this.setupProductGallery);
    }
    connectedCallback() {
      this.product_container = this.closest(".thb-product-detail");
      this.thumbnail_container = this.product_container.querySelector( ".product-thumbnail-container" );
      this.video_containers = this.querySelectorAll( ".product-single__media-external-video--play" );
      this.setOptions();
      // Start Slider
      if (this.flkty) {
        this.reInit();
      }
      else {
        this.init();
      }
    }
    setOptions() {
      this.hide_variants = this.dataset.hideVariants == "true";
      if (this.thumbnail_container) {
        this.thumbnails = this.thumbnail_container.querySelectorAll(".product-thumbnail");
      }
      this.prev_button = this.querySelector(".flickity-prev");
      this.next_button = this.querySelector(".flickity-next");
      this.options = {
        wrapAround: true,
        pageDots: true,
        contain: true,
        adaptiveHeight: true,
        initialIndex: ".is-active.is-initial-selected",
        prevNextButtons: false,
        fade: false,
        cellSelector: ".product-images__slide.is-active",
      };

      if (this.classList.contains("product-quick-images")) {
        this.options.cellAlign = "left";
        this.options.imagesLoaded = true;
        this.options.pageDots = false;
        this.options.freeScroll = true;
        this.options.wrapAround = false;
      }
    }
    init() {
      this.flkty = new Flickity(this, this.options);
      this.selectCell(".product-images__slide.is-initial-selected");
      $("#Product-Slider").find(".product-images__slide").removeClass('is-selected');
      $("#Product-Slider").find(".product-images__slide.is-initial-selected").addClass('is-selected');
      
      this.selectedIndex = this.flkty.selectedIndex;

      // Setup Events
      this.setupEvents();

      // Start Gallery
      this.setupProductGallery();
    }
    reInit() {
      if (this.flkty) {
        this.flkty.destroy();
      }

      this.setOptions();

      this.flkty = new Flickity(this, this.options);

      // Setup Events
      this.setupEvents();
      this.flkty.reloadCells();

      this.selectedIndex = this.flkty.selectedIndex;
    }
    filterActiveCells() {
      this.flkty.cells.forEach(cell => {
        const elem = cell.element;
        if (elem.classList.contains('is-active')) {
            elem.style.display = 'block';
        } else {
          elem.style.display = 'none';
        }
      });
      this.flkty.reloadCells();
    }
    setupEvents() {
      const _this = this;
      if (this.prev_button) {
        let prev = this.prev_button.cloneNode(true);
        this.prev_button.parentNode.append(prev);
        this.prev_button.remove();
        prev.addEventListener("click", (event) => {
          this.flkty.previous();
        });
        prev.addEventListener("keyup", (event) => {
          this.flkty.previous();
          event.preventDefault();
        });
      }
      if (this.next_button) {
        let next = this.next_button.cloneNode(true);
        this.next_button.parentNode.append(next);
        this.next_button.remove();
        next.addEventListener("click", (event) => {
          this.flkty.next();
        });
        next.addEventListener("keyup", (event) => {
          this.flkty.next();
          event.preventDefault();
        });
      }
      this.flkty.on("settle", function (index) {
        _this.selectedIndex = index;
      });
      this.flkty.on("change", (index) => {
        // _this.filterActiveCells();
        const fCells = this.flkty.cells[_this.selectedIndex];
        if (!fCells) {
          return;
        }
        let previous_slide = fCells.element,
          previous_media = previous_slide.querySelector(
            ".product-single__media"
          ),
          slide = this.flkty.cells[index].element,
          media = slide.querySelector(".product-single__media"),
          active_thumb = false;
        if (this.thumbnail_container) {
          let active_thumbs = Array.from(_this.thumbnails).filter((element) =>
              element.classList.contains("is-active")
            ),
            active_thumb = active_thumbs[index]
              ? active_thumbs[index]
              : active_thumbs[0];
          _this.thumbnails.forEach((item, i) => {
            item.classList.remove("is-initial-selected");
          });
          active_thumb.classList.add("is-initial-selected");
          active_thumb.classList.add("is-active");
        }
        requestAnimationFrame(() => {
          if (active_thumb) {
            if (active_thumb.offsetParent === null) {
              return;
            }
            const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
              windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
            active_thumb.parentElement.scrollTo({
              left:
                active_thumb.offsetLeft -
                windowHalfWidth +
                active_thumb.clientWidth / 2,
              top:
                active_thumb.offsetTop -
                windowHalfHeight +
                active_thumb.clientHeight / 2,
              behavior: "smooth",
            });
          }
        });

        // Stop previous video
        if (
          previous_media.classList.contains(
            "product-single__media-external-video"
          )
        ) {
          if (previous_media.dataset.provider === "youtube") {
            previous_media.querySelector("iframe").contentWindow.postMessage(
              JSON.stringify({
                event: "command",
                func: "pauseVideo",
                args: "",
              }),
              "*"
            );
          } else if (previous_media.dataset.provider === "vimeo") {
            previous_media.querySelector("iframe").contentWindow.postMessage(
              JSON.stringify({
                method: "pause",
              }),
              "*"
            );
          }
        } else if (
          previous_media.classList.contains(
            "product-single__media-native-video"
          )
        ) {
          previous_media.querySelector("video").pause();
        }

        // Draggable.
        if (media.classList.contains("product-single__media-model")) {
          this.setDraggable(false);
        } else {
          this.setDraggable(true);
        }
      });

      if (this.thumbnail_container) {
        setTimeout(() => {
          let active_thumbs = Array.from(this.thumbnails).filter(
            (element) => element.clientWidth > 0
          );
          active_thumbs.forEach((thumbnail, index) => {
            thumbnail.addEventListener("click", () => {
              this.thumbnailClick(thumbnail, index);
            });
          });
        });
      }
      let scrollbar = document.querySelector(
        ".product-quick-images__scrollbar>div"
      );

      if (scrollbar) {
        this.flkty.on("scroll", function (progress) {
          progress = Math.max(0, Math.min(1, progress));
          scrollbar.style.transform = "scaleX(" + progress + ")";
        });
      }
    }
    thumbnailClick(thumbnail, index) {
      this.thumbnails.forEach(function (el) {
        el.classList.remove("is-initial-selected");
      });
      thumbnail.classList.add("is-initial-selected");
      this.flkty.select(index);
    }
    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }
    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }
    setupProductGallery() {
      if (!this.querySelectorAll(".product-single__media-zoom").length) {
        return;
      }
      this.setEventListeners();
      this.reInit();
    }
    buildItems() {
      this.activeImages = Array.from(
        this.querySelectorAll(
          ".product-images__slide.is-active .product-single__media-image"
        )
      );

      return this.activeImages.map((item) => {
        let index = [].indexOf.call(
          item.parentNode.parentNode.children,
          item.parentNode
        );

        let activelink = item.querySelector(".product-single__media-zoom");
        activelink.dataset.index = index;
        return {
          src: activelink.getAttribute("href"),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h,
        };
      });
    }
    setEventListeners() {
      this.links = this.querySelectorAll(".product-single__media-zoom");
      this.pswpElement = document.querySelectorAll(".pswp")[0];
      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: false,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector(
              ".product-images__slide.is-selected"
            ),
            pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width,
          };
        },
      };
      const that = this;
      this.links.forEach((link) => {
        link.addEventListener("click", (e) => that.zoomClick(e, link));
      });
    }
    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== "undefined") {
        let pswp = new PhotoSwipe(
          this.pswpElement,
          PhotoSwipeUI_Default,
          this.items,
          this.pswpOptions
        );
        pswp.listen("firstUpdate", function () {
          pswp.listen("parseVerticalMargin", function (item) {
            item.vGap = {
              top: 50,
              bottom: 50,
            };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }
  }
  customElements.define("product-slider", ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector("cart-notification");
        this.body = document.body;

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.form.reportValidity()) {
          return;
        }
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains("loading")) return;

        this.handleErrorMessage();

        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");

        const config = {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/javascript",
          },
        };
        const formData = new FormData(this.form);
        formData.append(
          "sections",
          this.getSectionsToRender().map((section) => section.section)
        );
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${theme.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              dispatchCustomEvent("product:variant-error", {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              return;
            }

            this.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("aria-disabled");
          });
      }

      getSectionsToRender() {
        return [
          {
            id: "Cart",
            section: "main-cart",
            selector: ".thb-cart-form",
          },
          {
            id: "Cart-Drawer",
            section: "cart-drawer",
            selector: ".cart-drawer",
          },
          {
            id: "cart-drawer-toggle",
            section: "cart-bubble",
            selector: ".thb-item-count",
          },
        ];
      }
      renderContents(parsedState) {
        this.getSectionsToRender().forEach((section) => {
          if (!document.getElementById(section.id)) {
            return;
          }
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
          if (typeof CartDrawer !== "undefined") {
            new CartDrawer();
          }
          if (typeof Cart !== "undefined") {
            new Cart().renderContents(parsedState);
          }
        });

        if (document.getElementById("Cart-Drawer")) {
          this.body.classList.add("open-cc");
          document.getElementById("Cart-Drawer").classList.add("active");

          dispatchCustomEvent("cart-drawer:open");
        }

        let product_drawer = document.getElementById("Product-Drawer");
        if (product_drawer && product_drawer.contains(this)) {
          product_drawer.classList.remove("active");

          if (!document.getElementById("Cart-Drawer")) {
            this.body.classList.remove("open-cc");
          }
        }
      }
      getSectionInnerHTML(html, selector = ".shopify-section") {
        return new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector(selector).innerHTML;
      }
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

async function updateVariants() {
  const scriptTag = document.querySelector('variant-selects script[type="application/json"]');
  if (!scriptTag) return;

  try {
    const variants = JSON.parse(scriptTag.textContent.trim());
    const availableVariants = variants.filter(variant => variant.available);
    
    const container = document.querySelector('variant-selects .variations');
    if (!container) return;

    const fieldsets = container.querySelectorAll('fieldset.product-form__input');
    if (!fieldsets.length) return;

    const firstFieldset = fieldsets[0];
    const checkedRadio = firstFieldset.querySelector('input[type="radio"]:checked');
    if (checkedRadio) {
      const checkedValue = checkedRadio.value;
      const filteredAvailableVariants = availableVariants.filter(variant => variant.option1 === checkedValue);
      const firstAvailableVariant = filteredAvailableVariants[0];

      if (firstAvailableVariant) {
        await updateVariantOptions(fieldsets, firstAvailableVariant, availableVariants);
      }
    }
  } catch (error) {
    console.error("Error updating variants:", error);
  }
}

async function updateVariantOptions(fieldsets, firstAvailableVariant, availableVariants) {
  const { option2, option3, id, sku } = firstAvailableVariant;

  // Update size options
  if (fieldsets.length > 1) {
    const secondFieldset = fieldsets[1];
    updateFieldsetOptions(secondFieldset, option2, availableVariants, 'option2');
  }

  // Update cup options
  if (fieldsets.length > 2) {
    const thirdFieldset = fieldsets[2];
    updateFieldsetOptions(thirdFieldset, option3, availableVariants, 'option3');
  }

  // Update selected variant
  const selectedVariant = document.getElementById('selected-variant-id');
  if (selectedVariant) {
    selectedVariant.value = id;
  }

  // Update SKU
  const selectedSku = document.querySelector('.product-sku span.sku-value');
  if (selectedSku) {
    selectedSku.innerHTML = sku;
  }
}

function updateFieldsetOptions(fieldset, selectedOption, availableVariants, optionKey) {
  const radios = fieldset.querySelectorAll('input[type="radio"]');
  const selectedValue = fieldset.querySelector('legend.form__label span.form__label__value');

  radios.forEach(radio => {
    radio.checked = false;
    radio.classList.remove('is_selected', 'is-disabled');
  });
  radios.forEach(radio => {
    if (radio.value === selectedOption) {
      radio.classList.add('is_selected');
      radio.classList.remove('is-disabled');
      radio.checked = true;
      if (selectedValue) {
        selectedValue.textContent = radio.value;
      }
    } else {
      const isAvailable = availableVariants.some(variant => variant[optionKey] === radio.value);
      if (!isAvailable) {
        radio.classList.add('is-disabled');
        radio.classList.remove('is_selected');
        radio.checked = false;
      }
    }
  });
}

function initializeRadioButtons() {
  const radioButtons = document.querySelectorAll('variant-selects .variations fieldset.product-form__input:not([data-handle="color"]) input[type="radio"]');
  radioButtons.forEach(radio => {
    radio.addEventListener('change', handleRadioChange);
  });
}

function handleRadioChange(event) {
  const selectedRadio = event.target;
  const selectedValue = selectedRadio.value;
  const fieldset = selectedRadio.closest('fieldset.product-form__input');
  const fieldsets = document.querySelectorAll('variant-selects .variations fieldset.product-form__input');
  const fieldsetIndex = Array.from(fieldsets).indexOf(fieldset) + 1;
  const secondFieldset = fieldsets[1];
  const thirdFieldset = fieldsets[2];

  const scriptTag = document.querySelector('variant-selects script[type="application/json"]');
  
  if (!scriptTag) {
      console.error('Script tag not found');
      return;
  }
  
  let availableVariants = [];

  try {
      const jsonObject = JSON.parse(scriptTag.textContent.trim());
      if (Array.isArray(jsonObject)) {
          availableVariants = jsonObject.filter(variant => variant.available);
          unavailableVariants = jsonObject.filter(variant => !variant.available);
      } else {
          console.error('JSON is not an array');
          return;
      }
  } catch (error) {
      console.error('Error parsing JSON:', error);
      return;
  }
  
  let filteredAvailableVariants = [];

  if (fieldsetIndex === 2 && secondFieldset) {
      filteredAvailableVariants = availableVariants.filter(variant => variant.option2 === selectedValue);
      if (thirdFieldset) {
        updateFieldsetRadios(thirdFieldset, filteredAvailableVariants, 'option3');
      }
  } else if (fieldsetIndex === 3 && thirdFieldset) {
      filteredAvailableVariants = availableVariants.filter(variant => variant.option3 === selectedValue);
      if (secondFieldset) {
        updateFieldsetRadios(secondFieldset, filteredAvailableVariants, 'option2');
      }
  }
}

function updateFieldsetRadios(fieldset, filteredAvailableVariants, optionKey) {
  const radiosInFieldset = fieldset.querySelectorAll('input[type="radio"]');
  
  radiosInFieldset.forEach(radio => {
      if (filteredAvailableVariants.some(variant => variant[optionKey] === radio.value)) {
          radio.classList.remove('is-disabled');
      } else {
          radio.classList.remove('is_selected');
          radio.classList.add('is-disabled');
          radio.checked = false;
      }
  });
}
async function formatSizes() {
  const sizes = ["XXS", "XS", "XS/S", "S", "S/M", "M", "M/L", "L", "L/XL", "XL", "XXL", "1X", "2X", "3X", "4XL", "O/S"];
  const bands = ["26", "28", "30", "32", "34", "36", "38"];
  const cups = ["A", "B", "C", "D", "DD", "DDD", "E"];
  
  const fieldsetSize = document.querySelector('fieldset.product-form__input[data-handle="size"]');
  const fieldsetBand = document.querySelector('fieldset.product-form__input[data-handle="band"]');
  const fieldsetCup = document.querySelector('fieldset.product-form__input[data-handle="cup"]');
  
  function sortInputLabelPairs(pairs, orderArray = null, defaultSort = 'alphabetical') {
      pairs.sort((a, b) => {
          const aValue = a.input.value.toUpperCase();
          const bValue = b.input.value.toUpperCase();
          
          if (orderArray) {
              const aIndex = orderArray.indexOf(aValue);
              const bIndex = orderArray.indexOf(bValue);

              if (aIndex !== -1 && bIndex !== -1) {
                  return aIndex - bIndex;
              } else if (aIndex !== -1) {
                  return -1;
              } else if (bIndex !== -1) {
                  return 1;
              }
          }
          
          const aNumeric = parseFloat(aValue);
          const bNumeric = parseFloat(bValue);
          if (!isNaN(aNumeric) && !isNaN(bNumeric)) {
              return aNumeric - bNumeric;
          }

          return defaultSort === 'alphabetical' ? aValue.localeCompare(bValue) : 0;
      });
  }

  function formatFieldset(fieldset, orderArray = null, defaultSort = 'alphabetical') {
      if (fieldset) {
          const legend = fieldset.querySelector("legend.form__label");

          const inputLabelPairs = Array.from(fieldset.querySelectorAll('input[type="radio"]')).map((input) => {
              const label = fieldset.querySelector(`label[for="${input.id}"]`);
              return { input, label };
          });

          sortInputLabelPairs(inputLabelPairs, orderArray, defaultSort);

          inputLabelPairs.forEach((pair) => {
              pair.input.remove();
              pair.label.remove();
          });

          for (let i = inputLabelPairs.length - 1; i >= 0; i--) {
              legend.insertAdjacentElement("afterend", inputLabelPairs[i].label);
              inputLabelPairs[i].label.insertAdjacentElement("beforebegin", inputLabelPairs[i].input);
          }
      }
  }

  if (fieldsetSize) {
      formatFieldset(fieldsetSize, sizes);
  } else if (fieldsetBand) {
      formatFieldset(fieldsetBand, bands, 'numeric');
  } else if (fieldsetCup) {
      formatFieldset(fieldsetCup, cups, 'alphabetical');
  } else {
      const genericFieldset = document.querySelector('fieldset.product-form__input'); // Generic fallback
      if (genericFieldset) {
          const hasNumericValues = Array.from(genericFieldset.querySelectorAll('input[type="radio"]'))
              .some(input => !isNaN(parseFloat(input.value)));
      
          formatFieldset(genericFieldset, null, hasNumericValues ? 'numeric' : 'alphabetical');
      }
  }
}

window.addEventListener('load', async() => {
  initializeRadioButtons();
  // await updateVariants();
  await formatSizes();
  if (!customElements.get("product-slider")) {
    //wait for all images to load before initializing the product slider
    const sliderInterval = setInterval(() => {
      const variantOptions = document.querySelector('#variant-options');
      if (variantOptions && variantOptions?.classList.contains('loaded')) {
        clearInterval(sliderInterval);
        initializeProductSlider();
      }
    }, 100);
  }
});